(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function() {
    var form = document.querySelector('[data-cart-form]');
    if (!form) return;
    form.querySelectorAll('[data-cart-item]').forEach(function(item) {
      var input = item.querySelector('[data-qty-input]');
      var minus = item.querySelector('[data-qty-minus]');
      var plus = item.querySelector('[data-qty-plus]');
      if (input && minus) minus.addEventListener('click', function() {
        input.value = Math.max(0, (parseInt(input.value, 10) || 0) - 1);
        form.submit();
      });
      if (input && plus) plus.addEventListener('click', function() {
        input.value = (parseInt(input.value, 10) || 0) + 1;
        form.submit();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function() {
    var sortSelect = document.querySelector('[data-collection-sort]');
    if (!sortSelect) return;

    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    /* Mobile drawer toggle */
    var toggle = header.querySelector('[data-menu-toggle]');
    var drawer = header.querySelector('[data-menu-drawer]');

    if (toggle && drawer) {
      var menuFocusable = 'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])';
      var lastMenuFocus = null;

      function openMenu() {
        lastMenuFocus = document.activeElement;
        toggle.setAttribute('aria-expanded', 'true');
        drawer.removeAttribute('hidden');
        drawer.offsetHeight; /* reflow for transition */
        drawer.setAttribute('data-open', '');
        document.body.style.overflow = 'hidden';
        var first = drawer.querySelector(menuFocusable);
        if (first) first.focus();
      }
      function closeMenu() {
        toggle.setAttribute('aria-expanded', 'false');
        drawer.removeAttribute('data-open');
        drawer.setAttribute('hidden', '');
        document.body.style.overflow = '';
        if (lastMenuFocus && lastMenuFocus.focus) { lastMenuFocus.focus(); } else { toggle.focus(); }
      }

      toggle.addEventListener('click', function() {
        if (toggle.getAttribute('aria-expanded') === 'true') { closeMenu(); } else { openMenu(); }
      });

      /* Escape closes; Tab is trapped across the toggle + drawer while open. */
      document.addEventListener('keydown', function(e) {
        if (toggle.getAttribute('aria-expanded') !== 'true') return;
        if (e.key === 'Escape') { closeMenu(); return; }
        if (e.key === 'Tab') {
          var list = [toggle].concat(Array.prototype.slice.call(drawer.querySelectorAll(menuFocusable)))
            .filter(function(el) { return el.offsetParent !== null; });
          if (!list.length) return;
          var first = list[0], last = list[list.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });
    }

    /* Region dropdown (desktop) */
    var regionSelector = header.querySelector('[data-region-selector]');
    if (regionSelector) {
      var trigger = regionSelector.querySelector('[data-region-trigger]');
      var dropdown = regionSelector.querySelector('[data-region-dropdown]');
      var regionCloseTimer;

      function openRegion() {
        clearTimeout(regionCloseTimer);
        dropdown.removeAttribute('hidden');
        regionSelector.setAttribute('data-open', '');
        trigger.setAttribute('aria-expanded', 'true');
      }
      function closeRegion() {
        clearTimeout(regionCloseTimer);
        dropdown.setAttribute('hidden', '');
        regionSelector.removeAttribute('data-open');
        trigger.setAttribute('aria-expanded', 'false');
      }
      // Grace period so a brief slip outside the menu doesn't close it.
      function closeRegionSoon() {
        clearTimeout(regionCloseTimer);
        regionCloseTimer = setTimeout(closeRegion, 250);
      }

      trigger.addEventListener('mouseenter', openRegion);
      regionSelector.addEventListener('mouseenter', function() { clearTimeout(regionCloseTimer); });
      regionSelector.addEventListener('mouseleave', closeRegionSoon);

      // Click / tap toggle for touch and keyboard users.
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        if (regionSelector.hasAttribute('data-open')) { closeRegion(); } else { openRegion(); }
      });

      // Arrow-key navigation through the options.
      trigger.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          openRegion();
          var opts = dropdown.querySelectorAll('[data-region-option]');
          if (opts.length) { (e.key === 'ArrowDown' ? opts[0] : opts[opts.length - 1]).focus(); }
        }
      });
      Array.prototype.forEach.call(dropdown.querySelectorAll('[data-region-option]'), function(opt, i, arr) {
        opt.addEventListener('keydown', function(e) {
          if (e.key === 'ArrowDown') { e.preventDefault(); (arr[i + 1] || arr[0]).focus(); }
          else if (e.key === 'ArrowUp') { e.preventDefault(); (arr[i - 1] || arr[arr.length - 1]).focus(); }
          else if (e.key === 'Escape') { closeRegion(); trigger.focus(); }
        });
      });

      // Escape closes; a click anywhere outside closes.
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') closeRegion();
      });
      document.addEventListener('click', function(e) {
        if (!regionSelector.contains(e.target)) closeRegion();
      });
    }

    /* Highlight the region matching the current storefront, so the same theme
       shows the correct active region on each regional domain (not always the
       first/AU one). Inert on the preview / myshopify / B2B hosts. */
    (function() {
      var here = location.hostname.replace(/^www\./, '');
      function hostOf(a) { try { return new URL(a.href).hostname.replace(/^www\./, ''); } catch (e) { return ''; } }
      var desktop = header.querySelectorAll('[data-region-option]');
      var onRegionHost = false;
      desktop.forEach(function(o) { if (hostOf(o) === here) onRegionHost = true; });
      if (!onRegionHost) return; /* non-regional host: keep the Liquid default */

      var matched = null;
      desktop.forEach(function(o) {
        var on = hostOf(o) === here;
        o.classList.toggle('region-selector__option--active', on);
        if (on) matched = o;
      });
      header.querySelectorAll('[data-region-mobile]').forEach(function(o) {
        o.classList.toggle('header__drawer-region--active', hostOf(o) === here);
      });
      if (matched) {
        var flag = matched.querySelector('.region-selector__option-flag');
        var triggerFlag = header.querySelector('[data-region-flag]');
        if (flag && triggerFlag) triggerFlag.innerHTML = flag.innerHTML;
      }
    })();

    /* Predictive search — live suggestions (left) + product results (right).
       Fetches the `predictive-search` section via the Section Rendering API as
       the customer types, and renders it into the dropdown below the search pill. */
    var psWrap = header.querySelector('[data-predictive-search-form]');
    if (psWrap && psWrap.getAttribute('data-predictive-url')) {
      var psUrl = psWrap.getAttribute('data-predictive-url');
      var psLoadingText = psWrap.getAttribute('data-loading-text') || '';
      var psInput = psWrap.querySelector('[data-predictive-input]');
      var psResults = psWrap.querySelector('[data-predictive-results]');
      var psDebounce;
      var psController;
      var psCache = {};
      var psActive = -1;

      function psOptions() {
        return Array.prototype.slice.call(psResults.querySelectorAll('a[role="option"]'));
      }
      function psHighlight(opts) {
        opts.forEach(function(a, i) {
          var on = i === psActive;
          a.classList.toggle('is-active', on);
          a.setAttribute('aria-selected', on ? 'true' : 'false');
          if (on) {
            a.scrollIntoView({ block: 'nearest' });
            if (a.id) psInput.setAttribute('aria-activedescendant', a.id);
          }
        });
        if (psActive < 0) psInput.removeAttribute('aria-activedescendant');
      }
      function psOpen() {
        if (psResults.hasAttribute('hidden')) {
          psResults.removeAttribute('hidden');
          psInput.setAttribute('aria-expanded', 'true');
        }
      }
      function psClose() {
        psResults.setAttribute('hidden', '');
        psInput.setAttribute('aria-expanded', 'false');
        psInput.removeAttribute('aria-activedescendant');
        psActive = -1;
      }
      function psShow(markup) {
        psResults.innerHTML = markup;
        psActive = -1;
        psResults.removeAttribute('data-loading');
        psOpen();
      }
      function psFetch(term) {
        if (psCache[term]) { psShow(psCache[term]); return; }
        psOpen();
        psResults.setAttribute('data-loading', '');
        if (!psResults.innerHTML.trim() && psLoadingText) {
          psResults.innerHTML = '<p class="predictive-search__empty">' + psLoadingText + '</p>';
        }
        if (psController) psController.abort();
        psController = new AbortController();
        var url = psUrl + '?q=' + encodeURIComponent(term) +
          '&section_id=predictive-search' +
          '&resources[type]=query,product,collection,page,article' +
          '&resources[limit]=5&resources[limit_scope]=each';
        fetch(url, { signal: psController.signal })
          .then(function(r) { return r.text(); })
          .then(function(text) {
            var section = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('#shopify-section-predictive-search');
            var markup = section ? section.innerHTML : '';
            psCache[term] = markup;
            psShow(markup);
          })
          .catch(function(err) {
            if (err.name !== 'AbortError') psClose();
          });
      }

      psInput.addEventListener('input', function() {
        var term = psInput.value.trim();
        clearTimeout(psDebounce);
        if (term.length < 2) { psClose(); return; }
        psDebounce = setTimeout(function() { psFetch(term); }, 250);
      });
      psInput.addEventListener('focus', function() {
        if (psInput.value.trim().length >= 2 && psResults.innerHTML.trim()) psOpen();
      });
      psInput.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') { psClose(); return; }
        if (psResults.hasAttribute('hidden')) return;
        var opts = psOptions();
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          psActive = psActive + 1 >= opts.length ? 0 : psActive + 1;
          psHighlight(opts);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          psActive = psActive <= 0 ? opts.length - 1 : psActive - 1;
          psHighlight(opts);
        } else if (e.key === 'Enter') {
          if (psActive >= 0 && opts[psActive]) { e.preventDefault(); opts[psActive].click(); }
        }
      });

      document.addEventListener('click', function(e) {
        if (!psWrap.contains(e.target)) psClose();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-addresses]');
    if (!root) return;

    /* New address toggle */
    var newPanel = root.querySelector('[data-address-new]');
    root.querySelectorAll('[data-address-new-toggle]').forEach(function (b) {
      b.addEventListener('click', function () { if (newPanel) newPanel.hidden = !newPanel.hidden; });
    });
    root.querySelectorAll('[data-address-new-cancel]').forEach(function (b) {
      b.addEventListener('click', function () { if (newPanel) newPanel.hidden = true; });
    });

    /* Edit toggles */
    root.querySelectorAll('[data-address-edit-toggle]').forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-address-edit-toggle');
        var panel = root.querySelector('[data-address-edit="' + id + '"]');
        if (panel) panel.hidden = !panel.hidden;
      });
    });
    root.querySelectorAll('[data-address-edit-cancel]').forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-address-edit-cancel');
        var panel = root.querySelector('[data-address-edit="' + id + '"]');
        if (panel) panel.hidden = true;
      });
    });

    /* Delete confirmation */
    root.querySelectorAll('[data-address-delete]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        if (!window.confirm(b.getAttribute('data-confirm') || 'Delete this address?')) e.preventDefault();
      });
    });

    /* Country -> province linking (self-contained) */
    root.querySelectorAll('[data-country]').forEach(function (countrySelect) {
      var provinceSelect = root.querySelector('[data-province="' + countrySelect.getAttribute('data-country') + '"]');
      if (!provinceSelect) return;
      var wrapper = provinceSelect.closest('[data-province-wrapper]');
      var preselected = provinceSelect.getAttribute('data-selected') || '';

      /* Pre-select the saved country when editing an existing address */
      var defaultCountry = countrySelect.getAttribute('data-default');
      if (defaultCountry) countrySelect.value = defaultCountry;

      function sync() {
        var opt = countrySelect.options[countrySelect.selectedIndex];
        var provinces = [];
        try { provinces = JSON.parse(opt.getAttribute('data-provinces') || '[]'); } catch (e) {}
        provinceSelect.innerHTML = '';
        if (!provinces.length) {
          if (wrapper) wrapper.style.display = 'none';
          return;
        }
        provinces.forEach(function (p) {
          var o = document.createElement('option');
          o.value = p[0]; o.textContent = p[1];
          if (p[0] === preselected || p[1] === preselected) o.selected = true;
          provinceSelect.appendChild(o);
        });
        if (wrapper) wrapper.style.display = '';
      }
      countrySelect.addEventListener('change', sync);
      sync();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-customer-login]');
    if (!root) return;

    var loginPanel = root.querySelector('[data-login-panel]');
    var recoverPanel = root.querySelector('[data-recover-panel]');
    var recoverSuccess = root.querySelector('[data-recover-success]');

    function show(recover) {
      if (recover) {
        recoverPanel.setAttribute('aria-hidden', 'false');
        loginPanel.setAttribute('aria-hidden', 'true');
      } else {
        recoverPanel.setAttribute('aria-hidden', 'true');
        loginPanel.setAttribute('aria-hidden', 'false');
      }
    }

    /* Open recovery on link click or #recover hash; keep it open if a
       recovery request was just submitted (success message present). */
    root.querySelectorAll('[data-recover-toggle]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); show(true); });
    });
    root.querySelectorAll('[data-recover-cancel]').forEach(function (el) {
      el.addEventListener('click', function () { show(false); });
    });

    if (window.location.hash === '#recover' || recoverSuccess) {
      show(true);
      if (recoverSuccess) recoverSuccess.focus();
    } else {
      show(false);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.product-hero-section');
    if (!section) return;

    /* === Gallery thumbnails === */
    var gallery = section.querySelector('[data-product-gallery]');
    if (gallery) {
      gallery.querySelectorAll('[data-thumb]').forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          var idx = thumb.getAttribute('data-thumb');
          gallery.querySelectorAll('[data-image-slide]').forEach(function(s) { s.classList.remove('product-hero__image-slide--active'); });
          gallery.querySelectorAll('[data-thumb]').forEach(function(t) { t.classList.remove('product-hero__thumb--active'); });
          gallery.querySelector('[data-image-slide="' + idx + '"]').classList.add('product-hero__image-slide--active');
          thumb.classList.add('product-hero__thumb--active');
        });
      });
    }

    /* Show the Shopify image assigned to the selected variant. */
    function showGalleryImageById(imageId) {
      if (!gallery || !imageId) return;

      var targetSlide = gallery.querySelector(
        '[data-image-slide][data-image-id="' + imageId + '"]'
      );
      var targetThumb = gallery.querySelector(
        '[data-thumb][data-image-id="' + imageId + '"]'
      );

      /* Leave the current image in place when the variant has no matching image. */
      if (!targetSlide) return;

      gallery.querySelectorAll('[data-image-slide]').forEach(function(slide) {
        slide.classList.remove('product-hero__image-slide--active');
      });
      gallery.querySelectorAll('[data-thumb]').forEach(function(thumb) {
        thumb.classList.remove('product-hero__thumb--active');
      });

      targetSlide.classList.add('product-hero__image-slide--active');
      if (targetThumb) targetThumb.classList.add('product-hero__thumb--active');
    }

    /* === Variant selector (single panel) === */
    var variantsJson = section.querySelector('[data-product-variants]');
    if (!variantsJson) return;

    var variants = JSON.parse(variantsJson.textContent);
    var ctaArea = section.querySelector('[data-product-cta]');
    var initial = section.querySelector('[data-cta-initial]');
    var selector = section.querySelector('[data-variant-selector]');
    if (!selector) return;

    var optionGroups = Array.from(section.querySelectorAll('[data-option-group]'));
    var optionCount = optionGroups.length;
    var selections = {}; /* { optionIndex: value } */

    var variantInput = section.querySelector('[data-variant-id]');
    var addBtn = section.querySelector('[data-add-btn]');
    var addText = section.querySelector('[data-add-text]');
    var addPrice = section.querySelector('[data-add-price]');
    var priceDisplay = section.querySelector('[data-product-price]');
    var unavailableMsg = section.querySelector('[data-unavailable-msg]');

    /* Button labels come from data attributes (Liquid does not render in JS blocks) */
    var txtSelect = addBtn.getAttribute('data-text-select') || 'Select options';
    var txtAdd = addBtn.getAttribute('data-text-add') || 'Add to cart';
    var txtSoldOut = addBtn.getAttribute('data-text-soldout') || 'Sold out';

    /*
     * Order the option groups: Single/Pair → Style → Size, regardless of how
     * they're ordered in Shopify admin. Unknown options keep their admin order
     * at the end. Re-insert each sorted group before the add-to-cart form.
     */
    var optionPriority = {
      'single/pair': 0, 'single / pair': 0, 'quantity': 0, 'pack': 0,
      'style': 1, 'type': 1, 'model': 1, 'colour': 1, 'color': 1,
      'size': 2
    };
    var formEl = selector.querySelector('form');
    optionGroups.slice().sort(function(a, b) {
      var al = (a.querySelector('.product-hero__option-label') || {}).textContent || '';
      var bl = (b.querySelector('.product-hero__option-label') || {}).textContent || '';
      var ap = optionPriority[al.trim().toLowerCase()]; if (ap === undefined) ap = 99;
      var bp = optionPriority[bl.trim().toLowerCase()]; if (bp === undefined) bp = 99;
      return ap - bp;
    }).forEach(function(g) {
      if (formEl) selector.insertBefore(g, formEl);
    });

    function formatMoney(cents) {
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AUD';
      var formatter = new Intl.NumberFormat(undefined, { style: 'currency', currency: currency, minimumFractionDigits: 2 });
      return formatter.format(cents / 100);
    }

    /* A variant matches the current selection, optionally ignoring one option index */
    function variantMatches(v, ignoreIdx) {
      for (var i = 0; i < optionCount; i++) {
        if (i === ignoreIdx) continue;
        if (selections[i] != null && v.options[i] !== selections[i]) return false;
      }
      return true;
    }

    /* True if some in-stock variant has `value` at `idx` given the other selections */
    function valueAvailable(idx, value) {
      return variants.some(function(v) {
        return v.available && v.options[idx] === value && variantMatches(v, idx);
      });
    }

    /* Strike through any option value that can't lead to an available purchase */
    function refreshAvailability() {
      section.querySelectorAll('[data-option-value]').forEach(function(btn) {
        var idx = parseInt(btn.getAttribute('data-option-idx'), 10);
        var value = btn.getAttribute('data-option-value');
        var unavailable = !valueAvailable(idx, value);
        btn.classList.toggle('product-hero__option-btn--unavailable', unavailable);
      });
    }

    function applyVariant(match) {
      if (unavailableMsg) unavailableMsg.hidden = true;

      if (match) {
        if (variantInput) variantInput.value = match.id;
        var formatted = formatMoney(match.price);
        if (priceDisplay) priceDisplay.textContent = formatted;

        if (match.featured_image && match.featured_image.id) {
          showGalleryImageById(match.featured_image.id);
        }

        if (match.available) {
          addBtn.disabled = false;
          addText.textContent = txtAdd;
          addPrice.textContent = formatted;
        } else {
          addBtn.disabled = true;
          addText.textContent = txtSoldOut;
          addPrice.textContent = '';
        }

        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      } else {
        /* Complete selection but the combination doesn't exist */
        addBtn.disabled = true;
        addText.textContent = txtSoldOut;
        addPrice.textContent = '';
        if (unavailableMsg) unavailableMsg.hidden = false;
      }
    }

    function updateVariant() {
      /* Products with no options: single variant, always selectable */
      if (optionCount === 0) {
        applyVariant(variants[0]);
        return;
      }

      var complete = true;
      for (var i = 0; i < optionCount; i++) {
        if (selections[i] == null) { complete = false; break; }
      }

      if (!complete) {
        addBtn.disabled = true;
        addText.textContent = txtSelect;
        addPrice.textContent = '';
        if (unavailableMsg) unavailableMsg.hidden = true;
        return;
      }

      var match = variants.find(function(v) {
        for (var i = 0; i < optionCount; i++) {
          if (v.options[i] !== selections[i]) return false;
        }
        return true;
      });
      applyVariant(match);
    }

    function refresh() {
      refreshAvailability();
      updateVariant();
    }

    function showSelector() {
      if (initial) initial.hidden = true;
      selector.hidden = false;
      refresh();
    }

    function hideSelector() {
      selector.hidden = true;
      if (initial) initial.hidden = false;
    }

    /* "Already Sized? Purchase Now" */
    var showBtn = section.querySelector('[data-show-selector]');
    if (showBtn) showBtn.addEventListener('click', showSelector);

    /* Cancel */
    var hideBtn = section.querySelector('[data-hide-selector]');
    if (hideBtn) hideBtn.addEventListener('click', hideSelector);

    /* Mobile purchase button — reveal the panel and scroll to it */
    var mobileBtn = section.querySelector('[data-mobile-purchase]');
    if (mobileBtn) {
      mobileBtn.addEventListener('click', function() {
        showSelector();
        if (ctaArea) ctaArea.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    /* Option value clicks — single select per group, then recompute */
    section.querySelectorAll('[data-option-value]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var optIdx = parseInt(btn.getAttribute('data-option-idx'), 10);
        var value = btn.getAttribute('data-option-value');

        var group = btn.closest('[data-option-group]');
        if (group) {
          group.querySelectorAll('[data-option-value]').forEach(function(b) {
            b.classList.remove('product-hero__option-btn--active');
          });
        }
        btn.classList.add('product-hero__option-btn--active');
        selections[optIdx] = value;

        refresh();
      });
    });

    /* Quantity stepper — the input is named "quantity" so its value posts with
       the native product form; the +/- buttons just nudge it, clamped to >= 1. */
    var qtyInput = section.querySelector('[data-qty-input]');
    var qtyDec = section.querySelector('[data-qty-decrease]');
    var qtyInc = section.querySelector('[data-qty-increase]');
    function getQty() {
      var n = parseInt(qtyInput && qtyInput.value, 10);
      if (isNaN(n) || n < 1) n = 1;
      return n;
    }
    function setQty(n) {
      if (n < 1) n = 1;
      if (qtyInput) qtyInput.value = n;
    }
    if (qtyDec) qtyDec.addEventListener('click', function() { setQty(getQty() - 1); });
    if (qtyInc) qtyInc.addEventListener('click', function() { setQty(getQty() + 1); });
    if (qtyInput) qtyInput.addEventListener('change', function() { setQty(getQty()); });

    /* Init — in direct-purchase mode the selector is already visible, so
       compute availability immediately; otherwise just prime the button label. */
    if (selector && !selector.hidden) {
      refresh();
    } else {
      updateVariant();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["riders-review-wall"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STAR = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>';

    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

    function card(r) {
      var stars = ''; for (var i = 0; i < r.rating; i++) { stars += STAR; }
      var sub = r.subtitle || 'Verified Rider';
      var photo = r.image
        ? '<div class="review-wall__photo"><img src="' + esc(r.image) + '" alt="Photo from ' + esc(r.author) + '" loading="lazy" referrerpolicy="no-referrer"></div>'
        : '';
      return '<article class="review-wall__card' + (r.image ? ' review-wall__card--has-photo' : '') + '">'
        + photo
        + '<div class="review-wall__stars" aria-label="Rated ' + r.rating + ' out of 5">' + stars + '</div>'
        + '<p class="review-wall__quote">' + esc(r.body) + '</p>'
        + '<hr class="review-wall__divider">'
        + '<footer class="review-wall__footer">'
        + '<div class="review-wall__byline">'
        + '<span class="review-wall__name">' + esc(r.author) + '</span>'
        + '<span class="review-wall__subtitle">' + esc(sub) + '</span>'
        + '</div>'
        + '</footer></article>';
    }

    function init(root) {
      var cfg;
      try { cfg = JSON.parse(root.querySelector('.review-wall__config').textContent); } catch (e) { return; }
      if (!cfg.endpoint) { return; } // no proxy configured => keep static fallback
      var grid = root.querySelector('.review-wall__grid');
      if (!grid) { return; }
      var labels = (cfg.labels || []).map(function (s) { return String(s).trim(); }).filter(Boolean);
      var pool = [];
      var counts = {}; /* per-line totals from the proxy (match the product pages) */
      var activeFilter = 'All';
      var shown = 0;
      var initialCount = cfg.initialCount || 10;
      var loadStep = cfg.loadStep || initialCount;
      var moreWrap = root.querySelector('.review-wall__more');
      var moreBtn = root.querySelector('[data-rw-more]');

      var url = cfg.endpoint + (cfg.endpoint.indexOf('?') < 0 ? '?' : '&') + 'per_page=100';
      if (cfg.productId) { url += '&product=' + encodeURIComponent(cfg.productId); }

      fetch(url, { headers: { 'accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data || !data.reviews) { return; }
          pool = data.reviews
            .filter(function (r) { return r && r.body && String(r.body).trim() && r.rating >= cfg.minRating; })
            .map(function (r) {
              return {
                rating: r.rating,
                body: r.body,
                author: r.name || 'Verified Rider',
                product: r.product || '',
                subtitle: r.product || '',
                image: r.image || ''
              };
            });
          if (!pool.length) { return; } // keep fallback
          // Surface reviews that include a photo first (stable: original order
          // is preserved within the "has photo" and "no photo" groups).
          pool.sort(function (a, b) { return (b.image ? 1 : 0) - (a.image ? 1 : 0); });
          counts = data.counts || {};
          updateAggregate(data);
          buildPills();
          setFilter('All');
        })
        .catch(function () { /* keep static fallback */ });

      function norm(s) { return String(s == null ? '' : s).toLowerCase().replace(/[^a-z0-9]/g, ''); }
      function matches(label, r) {
        // Normalised compare so "TheraRide" matches "Thera Ride" / "Thera-Ride" etc.
        return r.product && norm(r.product).indexOf(norm(label)) !== -1;
      }
      function filtered() {
        return activeFilter === 'All' ? pool : pool.filter(function (r) { return matches(activeFilter, r); });
      }
      /* Render the first `shown` reviews of the active filter and toggle the
         "Show more" button when more remain. */
      function render() {
        var items = filtered();
        grid.innerHTML = items.slice(0, shown).map(card).join('');
        if (moreWrap) { moreWrap.hidden = shown >= items.length; }
      }
      /* Switch filter and reset back to the initial batch */
      function setFilter(label) {
        activeFilter = label;
        shown = initialCount;
        render();
      }
      if (moreBtn) {
        moreBtn.addEventListener('click', function () {
          shown += loadStep;
          render();
        });
      }
      function buildPills() {
        var bar = root.querySelector('.review-wall__filters');
        if (!bar || !cfg.showFilters || !labels.length) { if (bar) { bar.hidden = true; } return; }
        bar.innerHTML = '';
        labels.forEach(function (label) {
          var isAll = label === 'All';
          /* Use the proxy's per-line totals (which match the product pages, e.g.
             TheraRide 31) for the pill count, falling back to what's loaded. */
          var n = isAll ? 0 : (counts[label] != null ? counts[label] : pool.filter(function (r) { return matches(label, r); }).length);
          if (!isAll && n === 0) { return; } // hide pills with no reviews
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'review-wall__pill' + (isAll ? ' is-active' : '');
          b.textContent = isAll ? label : (label + ' (' + n + ')');
          b.addEventListener('click', function () {
            Array.prototype.forEach.call(bar.querySelectorAll('.review-wall__pill'), function (p) { p.classList.remove('is-active'); });
            b.classList.add('is-active');
            setFilter(label);
          });
          bar.appendChild(b);
        });
        bar.hidden = bar.children.length <= 1;
      }
      function updateAggregate(data) {
        var avgEl = root.querySelector('[data-rw-avg]');
        var numEl = root.querySelector('[data-rw-count]');
        if (data.average && avgEl) { avgEl.textContent = parseFloat(data.average).toFixed(1); }
        if (data.count && numEl) { numEl.textContent = parseInt(data.count, 10).toLocaleString(); }
      }
    }

    document.querySelectorAll('.review-wall').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["riders-video-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function embedFor(url) {
      var yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([\w-]{11})/);
      if (yt) return '<iframe src="https://www.youtube.com/embed/' + yt[1] + '?autoplay=1" allow="autoplay; fullscreen" allowfullscreen></iframe>';
      var vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (vm) return '<iframe src="https://player.vimeo.com/video/' + vm[1] + '?autoplay=1" allow="autoplay; fullscreen" allowfullscreen></iframe>';
      return '<video src="' + url + '" controls autoplay playsinline referrerpolicy="no-referrer"></video>';
    }

    function wire(root) {
      var lightbox = root.querySelector('.vreviews__lightbox');
      var player = root.querySelector('.vreviews__player');
      var closeBtn = root.querySelector('.vreviews__close');
      if (!lightbox || !player) return;

      function close() { lightbox.hidden = true; player.innerHTML = ''; }
      function open(url) { if (!url) return; player.innerHTML = embedFor(url); lightbox.hidden = false; }

      root.querySelectorAll('.vreviews__card').forEach(function (card) {
        card.addEventListener('click', function () { open(card.getAttribute('data-video')); });
      });
      closeBtn.addEventListener('click', close);
      lightbox.addEventListener('click', function (e) { if (e.target === lightbox) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lightbox.hidden) close(); });
    }

    document.querySelectorAll('.vreviews[data-section-id]').forEach(wire);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stockist-locator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var modal = document.getElementById('stockist-disclaimer');
    if (!modal) return;

    var STORAGE_KEY = 'sb_stockist_disclaimer_seen';
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      var first = modal.querySelector('[data-close]');
      if (first) first.focus();
    }

    function close() {
      modal.hidden = true;
      try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.hasAttribute('data-close')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });

    var seen = false;
    try { seen = sessionStorage.getItem(STORAGE_KEY) === '1'; } catch (e) {}
    // In the theme editor, always show so merchants can preview it.
    if (!seen || (window.Shopify && window.Shopify.designMode)) open();
  })();

  } catch(e) { console.error(e); }
})();
})();
